<template>
<div id="design">
    <Nav type="transparent" />
    <span class="pageTitle">空间设计</span>
    <div class="pContent">
        <div class="building">
            建设中，敬请期待～
        </div>
    </div>
</div>
</template>

<script>
import Nav from '@/components/Nav.vue'
export default {
    name: 'Design',
    data (){
        return {

        }
    },
    components: {
        Nav,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
    #design {
        padding: 350px 0 40px;
        background: url(../assets/pDesign-banner.jpg) top/auto 350px no-repeat;
    }
    .pContent {
        margin: 0 auto;
        width: 90%;
        max-width: 1200px;
    }
    .building {
        height: 400px;
        font-size: 40px;
        line-height: 400px;
        text-align: center;
    }

    .mob {
        #design {
            padding: 350px 32px 140px;
            background: url(../assets/design-banner.jpg) top/100% no-repeat;
        }
        .building {
            height: 800px;
            line-height: 800px;
        }
    }
</style>
